<c-card *transloco="let t">
    <c-card-body class="px-2">

        <c-row *ngIf="safety_zone">
          <c-col class="col-12 col-lg-6">
            <h1>{{ t('Edit Map Zone') }} - {{safety_zone.name}}</h1>
          </c-col>
          <c-col class="col-12 col-lg-6 text-end mb-2">
            <c-row class="justify-content-end">
              <c-col xs="auto">

                <div class="btn-group mb-2 " role="group">
                  <button color="light" cButton class="" routerLink="/mgmt/safetyzones">
                    <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                    {{ t('Return to Map Zones') }}
                  </button>
                  <button cButton class="" color="danger" class="text-white" (click)="doDelete()">
                    <i class="fa-solid fa-x"></i> {{ t('Delete') }}
                  </button>
                </div>



              </c-col>
            </c-row>
          </c-col>
        </c-row>


        <c-row>
            <c-col class="col-12 col-lg-6" *ngIf="formGroup">


              <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">


                    <div class="form-group row mb-2">
                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Name') }}</label>
                      <div class="col-6">
                        <input
                          [formControlName]="'name'"
                          cFormControl
                          placeholder="{{ t('Name') }}"
                          [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                        />
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('A suitable name for this map zone')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                        <div *ngIf="submitted && f['name'].errors && f['name'].errors['invalid']" class="invalid-feedback">
                          {{ f['name'].errors['invalid'] }}
                        </div>
                        <div *ngIf="submitted && f['name'].errors && f['name'].errors['required']" class="invalid-feedback">
                          {{ t('A valid name is required') }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mb-2">
                        <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPencil"></svg> {{ t('Description') }}</label>
                        <div class="col-6">
                          <textarea
                            [formControlName]="'description'"
                            cFormControl
                            placeholder="{{ t('Description') }}"
                            [ngClass]="{ 'border-danger': submitted && f['description'].errors }"
                            rows="3"
                          ></textarea>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                      <label class="col-4 col-form-label text-start text-sm-end">{{ t('Latitude') }}</label>
                      <div class="col-4">
                        <input
                          [formControlName]="'lat'"
                          cFormControl
                          placeholder="{{ t('Latitude') }}"
                        />
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <label class="col-4 col-form-label text-start text-sm-end">{{ t('Longitude') }}</label>
                      <div class="col-4">
                        <input
                          [formControlName]="'lng'"
                          cFormControl
                          placeholder="{{ t('Longitude') }}"
                        />
                      </div>
                      <div class="col-4">
                        <button type="button" class="btn btn-outline-primary btn-sm" (click)="goToLatLng()"><i class="fa-solid fa-location-crosshairs"></i> Go</button>
                      </div>
                    </div>

                    <ng-container *ngIf="formGroup.value.radius > 0">
                        <p>{{ t('Drag the slider to change the radius') }}</p>
                        <ngx-slider formControlName="radius" [(value)]="formGroup.value.radius" [options]="options" (userChangeEnd)="changeRadius()"></ngx-slider>
                    </ng-container>
                    <br/><br/>


                    <button cButton class="px-4 text-white btn-info" type="submit">
                      <i class="fa-solid fa-check"></i> &nbsp;&nbsp;{{ t('Update the Map Zone') }}
                    </button>

              </form>


              <div class="card mt-3">
                <div class="card-header">
                  <h3>{{ t('Add Workers to the Map Zone') }}</h3>
                </div>
                <div class="card-body">
                  <p>{{ t('To add workers to this group please choose them here:') }}</p>
                    <form  [formGroup]="workerFormGroup" (ngSubmit)="doAddWorker()" class="row">

                  <div class="col-auto">
                    <div class="form-group row mb-2" >
                      <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon  name="cilUser"></svg> {{ t('Workers') }}</label>
                      <div class="col-8">
                        <ng-select [items]="okService.workers"
                          bindLabel="name"
                          bindValue="id"
                          [multiple]="true"
                          formControlName="ids">
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                      <button type="button" class="btn btn-outline-primary" type="submit">
                      <i class="fa-solid fa-check"></i> {{ t('Add the Workers') }}
                    </button>
                  </div>



                  </form>
                </div>
              </div>

            </c-col>
            <c-col class="col-12 col-lg-6">

                <div class="alert alert-info" role="alert" *ngIf="formGroup">
                    <i class="fa-solid fa-circle-info"></i> &nbsp;
                    <span *ngIf="formGroup.value.radius == 0">{{ t('Click on the map to add the map zone in that location') }}</span>
                    <span *ngIf="formGroup.value.radius != 0">{{ t('Click on the map to move the map zone to that location') }}</span>

                </div>

                <div id="map" class="safety-zone-map" #myMap></div>


            </c-col>
          </c-row>



          <div class="card mt-3" *ngIf="safety_zone">
            <div class="card-header">
              <c-row>
                <c-col xs="6">
              <h3>{{ t('The Workers in this Map Zone') }}</h3>
              </c-col>
              </c-row>
            </div>
            <div class="card-body">


              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('Name') }}</th>
                    <th scope="col">{{ t('PIN') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let worker of safety_zone.workers">
                    <td>
                      <button type="button" class="btn btn-info btn-sm text-white mb-1" routerLink="/mgmt/worker/{{worker.id}}"><i class="fa-solid fa-eye"></i> {{ t('View') }}</button>
                      <button type="button" class="btn btn-warning btn-sm text-white mx-1 mb-1" type="submit" (click)="doRemoveWorker(worker)"><i class="fa-solid fa-circle-xmark"></i> {{ t('Remove') }}</button>
                    </td>
                    <td><b>{{worker.name}}</b></td>
                    <td>{{worker.pin}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>

    </c-card-body>
</c-card>
